import Vue from 'vue'
import jzRequest from '@jz/request'
import store from '@/store'
import { ACCESS_TOKEN } from '@/store/token'

// http://jnpm.jzyx.com/-/web/detail/@jz/request
jzRequest.config({
  defaults: {
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API : '/api'
  },
  onRequest: props => {
    const { loading = true } = props || {}
    const headers = {}

    // 开启全局loading
    loading && Vue.prototype.$toast.loading({ forbidClick: true, duration: 0 })

    // 判断是否存在token, 如果存在的话, 则每个活动接口的 header 都需要加上
    if (store.getters.token) {
      headers[ACCESS_TOKEN] = store.getters.token
    }

    // 活动接口配置参数
    const params = {
      game_code: process.env.VUE_APP_GAME_CODE,
      activity_code: process.env.VUE_APP_ACT_CODE
    }
    if (props.method === 'post') {
      return {
        headers,
        data: jzRequest.stringify({ ...params, ...props.data })
      }
    } else {
      return { headers, params: { ...params, ...props.data } }
    }
  },
  onResponse: (response, props) => {
    const { code, msg } = response
    const { loading = true, mute, key } = props || {}

    // 关闭全局loading
    loading && Vue.prototype.$toast.clear()

    // code 不为零时，默认输出全局提示，可通过设置mute实现静默
    if (code !== 0 && msg) {
      if (!mute || (typeof mute === 'object' && mute.length && !mute.includes(code))) {
        Vue.prototype.$toast(msg)
      }
    }

    // token 失效
    if (code === 1003) {
      store.dispatch('clearToken')
      location.reload()
    }

    // 关键任务上报
    if (Vue.prototype.$bl && key && store.getters.abilities[key]) {
      const { success_switch } = store.getters.abilities[key]
      if (success_switch === 1) {
        Vue.prototype.$bl.event({
          key: key,
          success: code === 0
        })
      }
    }
  },
  onError: message => {
    // 关闭全局loading
    Vue.prototype.$toast.clear()
    Vue.prototype.$notify({ type: 'danger', message })
  }
})

// 获取活动配置数据
// https://www.apifox.cn/web/project/1741548/apis/api-47647631
export function fetchConfig() {
  return jzRequest({
    url: '/activity/info',
    mute: true,
    loading: false
  })
}

// 获取栏目内容
// https://www.apifox.cn/link/project/1741548/apis/api-54895060
export function fetchLocalContent(data) {
  return jzRequest({
    url: '/activity/columnContent',
    data,
    mute: true,
    loading: false
  })
}

// 登录
// https://www.apifox.cn/web/project/1741548/apis/api-47421173
export function login(data) {
  return jzRequest({
    url: '/activity/login',
    method: 'post',
    data,
    key: 'login'
  })
}

// 获取验证码
// https://www.apifox.cn/web/project/1741548/apis/api-47090760
export function sendCode(data) {
  return jzRequest({
    url: '/activity/sendVerifyCode',
    method: 'post',
    data
  })
}

// 获取玩家相关数据
// https://www.apifox.cn/web/project/1741548/apis/api-48065252
export function fetchUserInfo() {
  return jzRequest({
    url: '/activity/roleInfo'
  })
}

// 分享
// https://www.apifox.cn/web/project/1741548/apis/api-47888370
export function share(award) {
  return jzRequest({
    url: '/activity/share',
    loading: false,
    mute: true,
    key: 'share',
    // 分享加抽奖次数
    data: award && { btn_index: 'page' }
  })
}

// 获取获奖记录
// https://www.apifox.cn/link/project/1741548/apis/api-133553844
export function fetchAwardRecord() {
  return jzRequest({
    url: '/activity/awardLogsNew'
  })
}

// 领取礼包
// https://www.apifox.cn/link/project/1741548/apis/api-53513145
export function collectAward(giftId) {
  return jzRequest({
    url: '/activity/sendAward',
    method: 'post',
    data: {
      award_id: Number(giftId)
    }
  })
}

// 抽奖
// https://www.apifox.cn/link/project/1741548/apis/api-55819191
export function lottery() {
  return jzRequest({
    url: '/activity/draw',
    method: 'post'
  })
}

// 绑定收货地址
// http://rap.jzyx.com/repository/editor?id=38&itf=655
export function bindAddress(data) {
  return jzRequest({
    url: '/activity/fillReceived',
    method: 'post',
    data
  })
}

// 自定义数据存储
// https://www.apifox.cn/link/project/1741548/apis/api-132760539
export function saveExtendInfo(data) {
  return jzRequest({
    url: '/activity/customExtra',
    method: 'post',
    data: { extra: JSON.stringify(data) }
  })
}

// 事件记录
// https://www.apifox.cn/link/project/1741548/apis/api-57832502
export function eventLog(event) {
  return jzRequest({
    url: '/activity/signEventLog',
    loading: false,
    mute: true,
    data: { sign_event: event }
  })
}

// 签到初始化
// https://www.apifox.cn/web/project/1741548/apis/api-250205332
export function fetchSigninInfo(data) {
  return jzRequest({
    url: '/signIn/init',
    ...(data && { data })
  })
}

// 签到
// https://www.apifox.cn/web/project/1741548/apis/api-250205333
export function signin(data) {
  return jzRequest({
    url: '/signIn/sign',
    method: 'post',
    ...(data && { data })
  })
}

// 签到奖励领取
// https://www.apifox.cn/link/project/1741548/apis/api-250205334
export function collectSigninAward(giftId) {
  return jzRequest({
    url: '/signIn/sendAward',
    method: 'post',
    data: {
      award_id: Number(giftId)
    }
  })
}

// 队伍信息初始化
// https://www.apifox.cn/web/project/1741548/apis/api-233981898
export function fetchTeamInfo() {
  return jzRequest({
    url: '/team/init'
  })
}

// 创建队伍
// https://www.apifox.cn/link/project/1741548/apis/api-233984785
export function createTeam(data) {
  return jzRequest({
    url: '/team/create',
    method: 'post',
    data
  })
}

// 加入队伍
// https://www.apifox.cn/link/project/1741548/apis/api-234119737
export function joinTeam(inviteCode) {
  return jzRequest({
    url: '/team/join',
    method: 'post',
    data: { t_code: inviteCode },
    mute: true
  })
}

// 根据邀请码获取队伍信息
// https://www.apifox.cn/link/project/1741548/apis/api-235700943
export function fetchTeamInfoByInviteCode(inviteCode) {
  return jzRequest({
    url: '/team/infoByCode',
    method: 'post',
    data: { t_code: inviteCode }
  })
}
